import { FilterStringField, PulseItem, PulseNode } from '~/types/api.graphql';

/**
 * Creates a filter for PulseTopics from selected categories
 * @param selectedTopics Array of PulseNode objects from SignalContext
 * @returns A structured filter for GraphQL queries
 */
export const pulseTopicToGraphQLFilter = (selectedTopics: PulseNode[]) =>
  pulseTopicIdsToGraphQLFilter(selectedTopics.map((topic) => topic.id));

/**
 * Creates a filter for PulseTopics from topic ids
 * @param topicIds Pulse taxonomy topic ids
 * @returns A structured filter for GraphQL queries, or null when there are no ids
 */
export const pulseTopicIdsToGraphQLFilter = (topicIds: string[]) => {
  if (topicIds.length === 0) return null;

  return {
    stringFilter: {
      field: FilterStringField.PulseTopic,
      operator: {
        in: topicIds,
      },
    },
  };
};

/**
 * Converts an audience's stored Pulse items (category/subCategory/topic labels) back into
 * PulseNode shape for prefilling SignalContext's selectedTopics when editing an audience.
 * @param items PulseItem entries from AudiencePulseInfo.items
 * @returns PulseNode objects usable as selectedTopics
 */
export const pulseItemsToPulseNodes = (items: PulseItem[]): PulseNode[] =>
  items.map((item) => {
    const paths = [item.category, item.subCategory, item.topic].filter(Boolean);
    return { id: item.id, name: paths[paths.length - 1], paths, signalCount: 0 };
  });
